// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","wrapper":"scrollToTop-module__wrapper___3mBP1","button":"scrollToTop-module__button___3AiuB"};